import { render } from "./HomeDefault.vue?vue&type=template&id=5c80a6be&ts=true"
import script from "./HomeDefault.vue?vue&type=script&lang=ts"
export * from "./HomeDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__